<template lang="pug">
    v-container.mx-auto
        Form(
            v-if="validIntegrationAppointment && !isLoading"
            :update-integration-appointment="updateIntegrationAppointment"
            :current-campaign-customer="currentCampaignCustomer"
            :scoped-slot="scopedSlot"
            :slot-form-object="slotFormObject"
            :customer-vehicles="customerVehicles"
            :scoped-appointment="scopedAppointment"
            :set-integration-appointment-details="setIntegrationAppointmentDetails"
            :display-details-view="displayDetailsView"
            :display-slots-view="displaySlotsView"
        )

        .text-center(v-if="isLoading")
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 100px; margin-bottom: 100px;"
            )


</template>

<script lang="ts">
    import Vue from 'vue';

    //Components

    import Form from '@/components/communication_center/shared/tabs/integration/form.vue'

    // Data
    import {  UpdateIntegrationAppointment } from "@/data";

    export default Vue.extend({
        data() {
            return {
                isLoading: false,
            }
        },
        methods: {
            updateIntegrationAppointment(formAppointment){
                if(!this.validIntegrationAppointment || formAppointment === null) {
                    return;
                }

                const options = {
                    current_integration: this.currentIntegration || "",
                    appointment_date_time: formAppointment?.appointment_date_time || 0,
                    campaign_customer_id: this.currentCampaignCustomer?.campaign_customer_id || 0,
                    customer_comments: formAppointment?.customer_comments || "",
                    delivery_contact_same_as_customer: formAppointment?.delivery_contact_same_as_customer || null,
                    delivery_contact: formAppointment?.delivery_contact || null, 
                    integration_shop_sid: formAppointment?.shop_sid || "",
                    integration_service_advisor_sid: formAppointment?.service_advisor_sid || "",
                    integration_transportation_type_sid: formAppointment?.transportation_type_sid || "",
                    notify_customer: formAppointment?.notify_customer || null,
                    vehicle_sid: formAppointment?.vehicle_sid || "",
                    vehicle_year: formAppointment?.vehicle_year || "",
                    vehicle_make: formAppointment?.vehicle_make || "",
                    vehicle_model: formAppointment?.vehicle_model || "",
                    //Currently Unused feilds that can be added
                    // jobs: jobs,

                };

                this.isLoading = true;
                UpdateIntegrationAppointment(this.scopedAppointment.appointment_sid, options).then((response) => {
                    if (response?.Data?.integration_appointment?.appointment_sid?.length > 0) {
                        //find objects and update properties
                        this.handleUpdateIntegrationAppointments(response.Data.integration_appointment);
                        this.showSnackbar("success", "Successfully update this customer's integration appointment");
                        this.getCustomerVehicles();
                        this.displayDetailsView();
                        this.setIntegrationError(false);
                        this.setAppointmentIdForIntegration(response.Data.volie_appointment_id);
                    } else {
                        if (response?.Data?.api_status > 0){
                            this.setIntegrationError(response.Data.api_status);
                        } 
                        let err = "Unable to update this Integration Appointment";
                        if (response?.Error?.length > 0) {
                            err = response.Error;
                        }
                        this.showSnackbar("error", err);
                    }
                    this.isLoading = false;
                });

            },
        },
        computed: {
            validIntegrationAppointment(){
                return this.scopedAppointment?.appointment_sid?.length > 0;
            }

        },
        components: {
            Form,

        },
        props: {
            currentCampaignCustomer: Object,
            currentIntegration: String,
            customerVehicles: Array,
            displayDetailsView: Function,
            displaySlotsView: Function,
            getCustomerVehicles: Function,
            getIntegrationAppointments: Function,
            scopedSlot: Object,
            scopedAppointment: Object,
            setIntegrationAppointmentDetails: Function,
            setIntegrationError: Function,
            showSnackbar: Function,
            slotFormObject: Object,
            handleUpdateIntegrationAppointments: Function,
            setAppointmentIdForIntegration: Function, 
        },
        created() {
        },
        destroyed() {
        }
    });
</script>

<style lang="scss" scoped>
</style>
